import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';

import {isEmpty} from "../../helpers/general.helper";
import { storeSelectedSeats, storeSelectedCouch, clearSelectedSeatsAndCouch } from "../../actions/movietheaters.actions";

class HallMap extends Component {

    constructor(props){
        super(props);
        this.state = {
            selectedSeat: [],
            selectedCouch: [],
            unableSeat: [],
            couchSeats: []
        }
    }

    componentDidMount() {
        this.props.clearSelectedSeatsAndCouch([]);
        if (this.props.hallConfiguration && this.props.hallConfiguration.event_info){
            if (Array.isArray(this.props.hallConfiguration.event_info.seats_unavailable)){
                this.setState({unableSeat: this.props.hallConfiguration.event_info.seats_unavailable})
            }
        }
    }

    componentWillReceiveProps(nextProps){
        if(this.props.hallConfiguration !== nextProps.hallConfiguration){
            this.props.clearSelectedSeatsAndCouch([]);
            this.setState({selectedSeat: []});
            this.setState({unableSeat: []});
            if (nextProps.hallConfiguration.event_info.seats_unavailable.length > 1){
                this.setState({unableSeat: nextProps.hallConfiguration.event_info.seats_unavailable});
            }
        }
    }

    selectSeat = (id_seat, code) => {
        const arr = this.props.hallConfiguration.room.seats.filter( (item) => item.id_parent === id_seat);
        const selectedSeats = [];
        let selectedCouch = [];
        if(!this.state.unableSeat.includes(id_seat)){  
            if (arr.length > 0){
                //the seat is part of couch
                if (!this.state.selectedSeat.find(elem => elem.id_seat === id_seat)){
                    this.state.selectedSeat.push({id_seat, code}, {id_seat: arr[0].id_seat, code: arr[0].code} );
                    selectedCouch.push({id_seat, code}, {id_seat: arr[0].id_seat, code: arr[0].code});
                    this.forceUpdate();           
                }
                else {
                    let index = this.state.selectedSeat.findIndex(elem => elem.id_seat === id_seat);
                    this.state.selectedSeat.splice(index, 1);  
                    selectedCouch.push({id_seat, code}, {id_seat: arr[0].id_seat, code: arr[0].code});
                    this.forceUpdate(); 
                }
            }  
            else{
                if (!this.state.selectedSeat.find(elem => elem.id_seat === id_seat)){
                    this.state.selectedSeat.push({id_seat, code});
                    this.forceUpdate();           
                    selectedSeats.push({id_seat, code});
                }
                else {
                    let index = this.state.selectedSeat.findIndex(elem => elem.id_seat === id_seat);
                    this.state.selectedSeat.splice(index, 1); 
                    selectedSeats.push({id_seat, code});  
                    this.forceUpdate();
                }
            }
            this.props.storeSelectedSeats(selectedSeats);
            this.props.storeSelectedCouch(selectedCouch);
        }
    }

    checkIfCouch = (seat) => {
        let isCouchClass = '';
        let idSeatClass = '';
        let completeClass = '';
        let htmlContent = '';
        if(seat) {
            const childs = this.props.hallConfiguration.room.seats.filter( (item) => item.id_parent === seat.id_seat);
            let seatState = " free";
            if(this.state.unableSeat.includes(seat.id_seat)) {
                seatState = " taken";
            }
            else if(this.state.selectedSeat.find(elem => elem.id_seat === seat.id_seat)) {
                seatState = " selected";
            }

            
            if(childs.length > 0) {
                idSeatClass = ' seat-id-' + seat['id_seat'];
                isCouchClass = seat['id_parent'] !== "0" ? ' is-couch parent-id-' + seat['id_parent'] : '';
                
                completeClass = idSeatClass + isCouchClass + seatState;
                htmlContent += "<div class='start-couch'>";
                htmlContent += "<div class='couch-overlay "+ completeClass +"'>&nbsp;</div>";
                htmlContent += "<span class='seat "+ completeClass +"'>&nbsp;</span>";
                htmlContent += childs.map((child) => {
                    const completeChildClass = ' seat-id-'+ child['id_seat'] + ' is-couch parent-id-' + seat['id_parent'];
                    return "<span class='seat "+completeChildClass+"'>&nbsp;</span>"
                });
                htmlContent += "</div>";
            } else {
                idSeatClass = ' seat-id-' + seat['id_seat'];
                isCouchClass = seat['id_parent'] !== "0" ? ' is-couch parent-id-' + seat['id_parent'] : '';
                completeClass = idSeatClass + isCouchClass + seatState;
                htmlContent += "<span class='seat "+ completeClass + "'>&nbsp;</span>";
            }
        }

        return htmlContent;
    };

    getReservationWidget = () => {
        let nrCols = this.props.hallConfiguration.room.cols;
        let nrRows = this.props.hallConfiguration.room.rows;
        let seatWrapperWidth = 100 / nrCols; //100% divided by the number of seats per row

        const htmlContent = [];
        let closingIndex = '';

        if(this.props.hallConfiguration.room.seats) {
            //iterate columns
            for(let i=0; i<nrRows; i++) {
                //iterate rows
                for(let j=0; j<nrCols; j++) {
                    //(i,j)
                    let arr = this.props.hallConfiguration.room.seats.filter( (seat, index) => {
                            if(seat['id_parent'] !== "0") {
                                closingIndex = index;
                            }
                            return parseInt(seat.row_no) === i && parseInt(seat.col_no) === j;
                        }
                    );

                    let class_name = 'hiddenCell';
                    if(arr.length && arr[0]['is_valid'] !== "0") {
                        class_name = 'visibleCell';
                    }

                    let couch = '';
                    let totalWidth = seatWrapperWidth;

                    if (arr.length){
                        if(arr[0]['id_parent'] === "0") {
                            couch = this.checkIfCouch(arr[0]);

                            const childs = this.props.hallConfiguration.room.seats.filter( (item) => item.id_parent === arr[0].id_seat);
                            if(childs.length > 0) {
                                totalWidth = seatWrapperWidth * 2;
                            }
                        }
                    } else {
                        couch = '<span class="seat free">&nbsp;</span>';
                    }

                    if( arr.length === 0 || couch != '') {
                        htmlContent.push(
                            <div className={`seat-wrapper ${class_name}`} style={{width: totalWidth + '%'}} onClick={() => arr.length ? this.selectSeat(arr[0].id_seat, arr[0].code) : null}>
                                {couch != '' ? <div dangerouslySetInnerHTML={{ __html: couch }}/> : ''}
                            </div>
                        );
                    }
                    closingIndex = '';
                }
            }
        }
        

        return (
            <Fragment>
                
                <div className="row">
                    <div className="col-lg-12">
                        <div className="seats">
                            {
                                htmlContent
                            }
                        </div>
                    </div>
                    <div className="col-xs-8 legend">
                        <span className="free" />
                        <span className="legend-text">LIBERE</span>
                        <span className="taken" />
                        <span className="legend-text">OCUPATE</span>
                        <span className="selected" />
                        <span className="legend-text">SELECTATE</span>
                    </div>
                </div>
            </Fragment>
        );
    };

    getHallConfigurationMessage = () => {
        return this.props.hallConfiguration ? <div className="text-center"><br/><span>Configurația sălii este momentan indisponibilă</span></div> : '';
   }

    render() {
        return (
            <Fragment>
                { this.props.hallConfiguration && this.props.hallConfiguration.room && this.props.hallConfiguration.room.id_room ? this.getReservationWidget() :
                   this.getHallConfigurationMessage() }                 
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    hallConfiguration: state.movieTheaters.hallConfiguration
});
export default connect(mapStateToProps, {storeSelectedSeats, storeSelectedCouch, clearSelectedSeatsAndCouch})(HallMap);






// WEBPACK FOOTER //
// ./src/SHARED/components/hallmap/hallmap.component.js